import SegmentUtils from 'utils/segment';

export default function trackOpenedSpotDetails({spotId}) {
    const properties = {
        spot_id: spotId,
    };

    SegmentUtils.track({
        event: 'Pin Preview Clicked',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 1,
                },
            },
        },
    });
}
